import {
  Box,
  Button,
  Card,
  Group,
  Stack,
  Table,
  Text,
  Title,
} from "@mantine/core";
import { Link, useNavigate } from "react-router-dom";
import { Run } from "tabler-icons-react";

import WorkforceBreadcrumbs from "./WorkforceBreadcrumbs";
import QueryWrapper from "../../common/components/QueryWrapper";
import { useListWorkforcesQuery } from "./workforce.api";
import { AccessRights } from "common/admin/auth/AccessRights";
import {
  ADMIN_ORGANIZATION,
  ADMIN_ROLE,
  WORKFORCE_CREATE_AUTHORISED_ORGANIZATIONS,
  WORKFORCE_CREATE_AUTHORISED_ROLES,
} from "_roles";
import { useOrganization } from "common/admin/auth/hooks";

export default function WorkforcesView() {
  const navigate = useNavigate();
  const [organization] = useOrganization();
  const listWorkforcesQuery = useListWorkforcesQuery();

  return (
    <Box>
      <div
        className="sticky top-0 z-50 pb-4"
        style={{ backgroundColor: "#E9ECEF" }}
      >
        <Title order={3} align={"center"} m={"xs"}>
          List of Staffs
        </Title>
        <WorkforceBreadcrumbs />
        <AccessRights
          authorizedOrganizations={WORKFORCE_CREATE_AUTHORISED_ORGANIZATIONS}
          authorizedRoles={WORKFORCE_CREATE_AUTHORISED_ROLES}
        >
          <Group position={"right"}>
            <Button className="bg-button-admin" component={Link} to="new">
              New
            </Button>
          </Group>
        </AccessRights>
      </div>
      <Card shadow={"sm"} p={"xl"} className={"overflow-visible"}>
        <QueryWrapper query={listWorkforcesQuery}>
          {(workforces) =>
            workforces.length ? (
              <Table highlightOnHover>
                <tbody>
                  {workforces
                    .filter(
                      (workforce) =>
                        workforce.organization === organization ||
                        organization === ADMIN_ORGANIZATION,
                    )
                    .map((workforce) => (
                      <tr
                        key={workforce.id}
                        onClick={() =>
                          navigate(workforce.id, { state: { workforce } })
                        }
                        style={{ display: "table-row", cursor: "pointer" }}
                      >
                        <td>
                          <Text variant="link">
                            {workforce.name || `Effectif ${workforce.id}`}
                          </Text>
                        </td>
                        <AccessRights
                          authorizedOrganizations={[ADMIN_ORGANIZATION]}
                          authorizedRoles={[ADMIN_ROLE]}
                        >
                          <td>{workforce.organization}</td>
                        </AccessRights>
                        <td>
                          <Group>
                            <Run />{" "}
                            <span>
                              <strong>{workforce.players.length}</strong>
                            </span>
                          </Group>
                        </td>
                      </tr>
                    ))}
                </tbody>
              </Table>
            ) : (
              <Stack align={"center"}>
                <Box>Aucun effectif trouvé</Box>
                <Button className="bg-button-admin" component={Link} to="new">
                  Nouvel effectif
                </Button>
              </Stack>
            )
          }
        </QueryWrapper>
      </Card>
    </Box>
  );
}
